import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const PCFHomePage = lazyWithChunkReload(() => import("./pcf.main").then((m) => ({ default: m.PCFHomePage })));
export const TemplateUploadPage = lazyWithChunkReload(() =>
  import("./template-import/pages/template-upload-page").then((m) => ({ default: m.TemplateUploadPage }))
);
export const PcfDetailsPage = lazyWithChunkReload(() =>
  import("./calculation-details/pcf-details.main").then((m) => ({ default: m.PcfDetailsPage }))
);
